// Request Best Price Popup Handler
(function() {
  'use strict';

  // DOM Elements
  const popup = document.getElementById('request-price-popup');
  const popupOverlay = popup?.querySelector('.popup-overlay');
  const closeBtn = popup?.querySelector('.popup-close');
  const form = document.getElementById('request-price-form');
  const successMessage = popup?.querySelector('.success-message');
  const closeSuccessBtn = popup?.querySelector('.close-success-btn');
  const requestPriceBtn = document.querySelector('.custom-btn--primary');

  // Open Popup
  function openPopup() {
    if (popup) {
      popup.style.display = 'flex';
      document.body.classList.add('popup-open');
      
      // Reset form and hide success message
      if (form) {
        form.reset();
        form.style.display = 'flex';
      }
      if (successMessage) {
        successMessage.style.display = 'none';
      }
    }
  }

  // Close Popup
  function closePopup() {
    if (popup) {
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
    }
  }

  // Show Success Message
  function showSuccessMessage() {
    if (form && successMessage) {
      form.style.display = 'none';
      successMessage.style.display = 'block';
    }
  }

  // Form Submission Handler
  async function handleFormSubmit(e) {
    e.preventDefault();

    const submitBtn = form.querySelector('.submit-btn');
    const btnText = submitBtn.querySelector('.btn-text');
    const btnLoading = submitBtn.querySelector('.btn-loading');

    // Get form data
    const formData = {
      name: document.getElementById('customer_name').value,
      email: document.getElementById('customer_email').value,
      phone: document.getElementById('customer_phone').value,
      message: document.getElementById('customer_message').value || 'No additional message',
      product_title: document.getElementById('product_title').value,
      product_url: document.getElementById('product_url').value,
      timestamp: new Date().toLocaleString('en-US', { 
        timeZone: 'Asia/Karachi',
        dateStyle: 'full',
        timeStyle: 'long'
      })
    };

    // Show loading state
    submitBtn.disabled = true;
    btnText.style.display = 'none';
    btnLoading.style.display = 'flex';

    try {
      // Prepare email body
      const emailBody = `
New Price Request Received

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
CUSTOMER INFORMATION
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Name:           ${formData.name}
Email:          ${formData.email}
Phone:          ${formData.phone}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
PRODUCT DETAILS
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Product:        ${formData.product_title}
Product URL:    ${formData.product_url}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
CUSTOMER MESSAGE
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

${formData.message}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Request submitted on: ${formData.timestamp}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Please respond to this customer as soon as possible.
      `.trim();

      // Send email using Shopify contact form endpoint
      const response = await fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'form_type': 'contact',
          'utf8': '✓',
          'contact[name]': formData.name,
          'contact[email]': formData.email,
          'contact[phone]': formData.phone,
          'contact[body]': emailBody
        })
      });

      if (response.ok || response.redirected) {
        // Success
        showSuccessMessage();
        
        // Track conversion (if analytics available)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'generate_lead', {
            'event_category': 'engagement',
            'event_label': 'request_best_price',
            'value': formData.product_title
          });
        }

        // Facebook Pixel (if available)
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead', {
            content_name: formData.product_title,
            content_category: 'price_request'
          });
        }
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Sorry, there was an error submitting your request. Please try again or contact us directly via WhatsApp.');
    } finally {
      // Reset button state
      submitBtn.disabled = false;
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';
    }
  }

  // Event Listeners
  if (requestPriceBtn) {
    requestPriceBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup();
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  if (popupOverlay) {
    popupOverlay.addEventListener('click', closePopup);
  }

  if (closeSuccessBtn) {
    closeSuccessBtn.addEventListener('click', closePopup);
  }

  if (form) {
    form.addEventListener('submit', handleFormSubmit);
  }

  // Close popup on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup && popup.style.display === 'flex') {
      closePopup();
    }
  });

  // Phone number formatting (Pakistan format)
  const phoneInput = document.getElementById('customer_phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function(e) {
      let value = e.target.value.replace(/\D/g, '');
      
      // Format: +30 691 234 5678
      if (value.startsWith('30')) {
        value = value.slice(2);
      } else if (value.startsWith('0')) {
        value = value.slice(1);
      }
      
      if (value.length > 0) {
        if (value.length <= 3) {
          e.target.value = '+30 ' + value;
        } else if (value.length <= 7) {
          e.target.value = '+30 ' + value.slice(0, 3) + ' ' + value.slice(3);
        } else {
          e.target.value = '+30 ' + value.slice(0, 3) + ' ' + value.slice(3, 10);
        }
      }
    });

    // Set default country code on focus
    phoneInput.addEventListener('focus', function(e) {
      if (!e.target.value) {
        e.target.value = '+30 ';
      }
    });
  }

  // Form validation
  const inputs = form?.querySelectorAll('input[required], textarea[required]');
  inputs?.forEach(input => {
    input.addEventListener('blur', function() {
      if (!this.validity.valid) {
        this.style.borderColor = '#ff4444';
      } else {
        this.style.borderColor = '#25D366';
      }
    });

    input.addEventListener('input', function() {
      if (this.style.borderColor === 'rgb(255, 68, 68)' && this.validity.valid) {
        this.style.borderColor = '#e0e0e0';
      }
    });
  });

  console.log('Request Best Price popup initialized successfully');
})();